var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrisisgoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5664 0H14.4336C6.46215 0 0 6.46215 0 14.4336V85.5664C0 93.5378 6.46215 100 14.4336 100H85.5664C93.5378 100 100 93.5378 100 85.5664V14.4336C100 6.46215 93.5378 0 85.5664 0Z",
    fill: "#ED1D15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9951 18.9784C60.7415 5.73234 39.2585 5.73234 26.0125 18.9784C12.7664 32.232 12.7664 53.715 26.0125 66.961L50.0076 90.9485L73.9951 66.961C87.2412 53.715 87.2412 32.232 73.9951 18.9784ZM70.8282 51.3018H55.0396V67.3797H44.694V51.3018H28.9053V41.4814H44.694V25.4035H55.0396V41.4814H70.8282V51.3018Z",
    fill: "#0E1130"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrisisgoLogo);
export default __webpack_public_path__ + "static/media/crisisgo-logo.927675a8ab6520184327b57b86f3d104.svg";
export { ForwardRef as ReactComponent };